import * as React from "react";
import { useState } from "react";
import i18n from "i18n";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Checkbox from "@material-ui/core/Checkbox";
import { default as firebase } from "common/Firebase";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { WBSStore } from "../../WBSStore";
import cone from "common/assets/images/coneTransparente.png";
import { ERowType } from "common/enums";
import { formatMonetary } from "utils/MathUtils";

const styles = (theme) => ({
  // Modal
  backgroundModal: {
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
  },
  modal: {
    width: "600px",
    borderRadius: "6px",
    overflow: "hidden",
    boxShadow: "0px 0px 20px #444",
    fontSize: "12px",
    fontFamily: "Roboto",
  },
  modalTitle: {
    padding: "22px 16px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #b1b1b1",
    "& p": { margin: "0px", fontSize: "24px", fontWeight: 700 },
  },
  modalBody: {
    padding: "18px 15px 0px 15px",
    backgroundColor: "#eee",
    "& p": { margin: "0px" },
  },
  replicateRow: {
    listStyle: "none",
    padding: "0",
    display: "flex",
    justifyContent: "space-between",
    fontWeight: 600,
    margin: "18px 0px 16px 0px",
  },
  searchBox: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginBottom: "16px",
  },
  // TextField
  search: {
    backgroundColor: "#fff",
    border: "solid 1px #333",
    margin: 0,
    "& div": {
      backgroundColor: "#fff!important",
      "& div": { margin: "0!important" },
      "& input": {
        height: "25px",
        padding: "0px",
        fontSize: "13px",
        "&:focus": { backgroundColor: "#fff" },
      },
    },
  },
  // Lista resultado da busca
  boxListSearch: { margin: "0px 0px 0px 0px" },
  list: {
    width: "100%",
    maxHeight: " 150px",
    minHeight: "150px",
    backgroundColor: "#fff",
    border: "1px solid #333",
  },
  listItem: { maxHeight: "20px", padding: "0" },
  listCheckbox: { padding: "0", color: "#666666!important" },
  listDados: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    color: "#333",
    border: "solid 1px #666",
    padding: "0px",
  },
  listDadosTree: {
    width: "90px",
    backgroundColor: "#eee",
    borderRight: "1px solid rgb(102, 102, 102)",
    flex: "1",
    padding: "3px 0px",
    paddingLeft: "10px",
  },
  listDadosDescricao: { flex: "4", padding: "3px 0px", paddingLeft: "10px" },
  notResult: {
    width: "100%",
    maxHeight: " 200px",
    minHeight: "200px",
    backgroundColor: "#fff",
    border: "1px solid #333",
    display: "flex",
    justifyContent: "center",
    "& p": { color: "#5c5c5c" },
  },
  notResulText01: { fontSize: "14px", fontWeight: 700, lineHeight: "20px" },
  notResulText02: { fontSize: "12px", fontWeight: 400, lineHeight: "25px" },
  // Lista de selecionados
  listSelected: {
    width: "100%",
    maxHeight: " 78px",
    minHeight: "78px",
    backgroundColor: "#ffffff",
    border: "1px solid #333",
  },
  listDadosSelected: {
    display: "flex",
    justifyContent: "flex-start",
    background: "#e7eeb7",
    width: "100%",
    color: "#333",
    border: "solid 1px #666",
    padding: "0px",
  },
  listDadosTreeSelected: {
    width: "90px",
    backgroundColor: "#d8deab",
    borderRight: "1px solid rgb(102, 102, 102)",
    flex: "1",
    padding: "3px 0px",
    paddingLeft: "10px",
  },
  listDadosDescricaoSelected: {
    flex: "4",
    padding: "3px 0px",
    paddingLeft: "10px",
  },
  // Selecionar todos
  selectAllBox: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: 400,
    fontSize: "12px",
    padding: "15px 0px 5px 0px",
    height: "34px",
  },
  btnSelectAll: { color: "#0441B9!important", cursor: "pointer", left: 0 },
  numericMarker: { right: 0 },
  // btn
  btnBox: {
    padding: "10px 0",
    display: "flex",
    justifyContent: "flex-end",
    "& button": { backgroundColor: "transparent", boxShadow: "none" },
  },
  btnCancel: { color: "#aaa" },
  btnNext: { color: theme.palette.primary.light },
});

let duplicateInfoRow: any = process.env.REACT_APP_COPY_DUPLICATE_INFO_ROW;

const ReplicateModal = (props) => {
  const { classes, selectedLine, dataList } = props;
  const [search, setSearch] = useState("");
  const [checked, setChecked] = useState([-1]);
  const [listSelected, setListSelected] = useState([]);
  const [listRow, setListRow] = useState([]);
  const itemLimit = 30; // Limite de linhas que pode selecionar para Replicar
  // lista com o parametro visible
  const listWithVisible = dataList.map((e) => {
    return { ...e, visible: true };
  });

  const addListSelected = (add, value) => {
    listRow.forEach((lista: any) => {
      if (lista.id === value) {
        if (listSelected.length === 0) {
          add.push(lista); // se a listSelected estiver vazia adiciona o elemento a lista
        } else {
          let cont = 0;
          listSelected.forEach((verif: any) => {
            if (verif.id === value) {
              // vefifica se o valor é igual ao id de algum elemento da listSelected
              cont++; // caso tenha encontrado algum elemento soma a variável
            }
          });
          if (cont <= 0) {
            add.push(lista); // caso a variável continue zerada adiciona o elemento a lista
          }
        }
      }
    });
  };

  // Add item a lista de selecionados
  const handleToggle = (value) => () => {
    if (listSelected.length >= itemLimit) {
      return;
    }
    let add: any = [...listSelected];
    let remov: any = [...listRow];
    addListSelected(add, value); // função que de fato add o item a ListSelected
    // Altera o valor do atributo visibile para false
    remov.forEach((e: any, index, arr: any) => {
      if (e.id === value) {
        e.visible = false;
      }
    });
    setListSelected(add); // atualiza o status[ListSelected] com a variavel add
    setListRow(remov); // atualiza o status[ListRow] com a variavel remov
  };

  // Add itens em lotes
  const sendBatch = (list) => {
    let newList = list.filter((e) => e.visible == true);
    let add: any = [...listSelected];
    let remov: any = [...listRow];
    let aux: any;
    let aux2: any = [];
    let insert = itemLimit - add.length;
    if (insert > 0) {
      for (let index = 0; index < insert; index++) {
        if (newList[index]) {
          addListSelected(add, newList[index].id);
          aux2.push(newList[index].id);
        }
      }
      remov.forEach((e: any, index, arr: any) => {
        for (let i = 0; i < aux2.length; i++) {
          if (e.id === aux2[i]) {
            e.visible = false;
          }
        }
      });
    }

    setListSelected(add);
    setListRow(remov);
  };

  // Remove item da lista de Selecionados
  const handleToggle_ = (value) => () => {
    let remov: any = [...listSelected];
    let insert: any = [...listRow];
    // Remove com splice o item da lista
    remov.forEach((e: any, index, arr: any) => {
      if (e.id === value) {
        arr.splice(index, 1);
      }
    });
    // Altera a propriedade visible para true
    insert.forEach((e: any, index, arr: any) => {
      if (e.id === value) {
        e.visible = true;
      }
    });

    setListSelected(remov); // atualiza o status[ListSelected] com a variavel remov
    setListRow(insert); // atualiza o status[ListRow] com a variavel insert
  };

  // Enviar os dados pra a cloudFunction processar os dados
  const process = async () => {
    const listSend = listSelected.map((list: any) => list.id);
    WBSStore.loading = true;

    try {
      const data = {
        wbsTotal: WBSStore.WBS.data.totalCost,
        wbsTotalSale: WBSStore.WBS.data.totalSale,
        wbsCalculate: WBSPropertiesStore.wbsCalculate,
        wbsId: WBSStore.WBS.id,
        rowId: selectedLine.id,
        allSelectedIds: listSend,
      };
      await axios.post(duplicateInfoRow, data);
    } catch (error) {
      console.error("error", error);
    } finally {
      WBSStore.replicateModal = false;
      WBSStore.loading = false;
    }
  };

  const cancelClick = () => {
    WBSStore.replicateModal = false;
  };

  const searchInput = async (value) => {
    setSearch(value);
    if (value.length >= 3) {
      filterList(value).then((lista) => {
        let array = [];
        if (lista.length > 120) {
          array = lista.slice(0, 119);
        } else {
          array = lista;
        }
        setListRow(array);
      });
    } else {
      setListRow([]);
    }
  };

  const filterList = async (value) => {
    let li: any = [],
      consult: any = listSelected;
    listWithVisible.filter((el) => {
      if (el.data.rowType !== ERowType.BLANK) {
        if (
          el.data.description.toLowerCase().indexOf(value.toLowerCase()) !==
            -1 &&
          value !== ""
        ) {
          if (el.id !== selectedLine.id) {
            let exists = false;
            if (consult.length > 0) {
              consult.forEach((e) => {
                if (e.id.indexOf(el.id) !== -1) {
                  exists = true;
                }
              });
            }
            if (exists) {
              let elN = { ...el, visible: false };
              li.push(elN);
            } else {
              li.push(el);
            }
          }
        }
      }
      return null;
    });
    return li;
  };

  const exibeLista = (listRow) => {
    return (
      <List className={classes.list} style={{ overflowY: "scroll" }}>
        {listRow.map(
          (value: any, index) =>
            value.visible === true && (
              <ListItem
                id={value.id.toString()}
                className={classes.listItem}
                key={value.id.toString()}
                role={undefined}
                button
                onClick={handleToggle(value.id)}
              >
                <Checkbox
                  className={classes.listCheckbox}
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                />
                <div className={classes.listDados}>
                  <div className={classes.listDadosTree}>{value.data.tree}</div>
                  <div className={classes.listDadosDescricao}>
                    {value.data.description.length > 60
                      ? value.data.description.substr(0, 60) + "..."
                      : value.data.description}
                  </div>
                </div>
              </ListItem>
            )
        )}
      </List>
    );
  };

  const exibeListaSelecionada = (listSelected) => {
    return (
      <List className={classes.listSelected} style={{ overflowY: "scroll" }}>
        {listSelected.map((value) => (
          <ListItem
            className={classes.listItem}
            key={value.id}
            role={undefined}
            dense
            button
            onClick={handleToggle_(value.id)}
          >
            <Checkbox
              className={classes.listCheckbox}
              checked={true}
              tabIndex={-1}
              disableRipple
            />
            <div className={classes.listDadosSelected}>
              <div className={classes.listDadosTreeSelected}>
                {value.data.tree}
              </div>
              <div className={classes.listDadosDescricaoSelected}>
                {value.data.description.length > 60
                  ? value.data.description.substr(0, 60) + "..."
                  : value.data.description}
              </div>
            </div>
          </ListItem>
        ))}
      </List>
    );
  };

  return (
    <>
      <div className={classes.backgroundModal} style={{ position: "absolute" }}>
        <div className={classes.modal}>
          <div className={classes.modalTitle}>
            <p>{i18n.replicate.title}</p>
          </div>
          <div className={classes.modalBody}>
            <p
              style={{
                textAlign: "center",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              {i18n.replicate.selctLineText}
            </p>
            <ul
              className={classes.replicateRow}
              style={{ textTransform: "uppercase" }}
            >
              <li>{selectedLine.data.tree}</li>
              <li>{selectedLine.data.description}</li>
              <li>{formatMonetary(selectedLine.data.total)}</li>
            </ul>
            <div className={classes.searchBox}>
              <TextField
                placeholder={i18n.replicate.inputPlaceholder}
                id="searchLine"
                margin="normal"
                variant="filled"
                fullWidth
                autoComplete="none"
                className={classes.search}
                autoFocus={true}
                color="primary"
                value={search}
                onChange={(e) => searchInput(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {" "}
                      <Search />{" "}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              {listSelected.length !== 0 && exibeListaSelecionada(listSelected)}
            </div>
            <div
              className={classes.selectAllBox}
              style={{ position: "relative" }}
            >
              {listRow.length > 0 && listSelected.length < itemLimit && (
                <p
                  className={classes.btnSelectAll}
                  onClick={(e) => sendBatch(listRow)}
                  style={{ position: "absolute" }}
                >
                  Selecionar Tudo
                </p>
              )}
              <p
                className={classes.numericMarker}
                style={{ position: "absolute" }}
              >
                {listSelected.length}/{itemLimit}
              </p>
            </div>
            <div className={classes.boxListSearch}>
              {listRow.length !== 0 ? (
                exibeLista(listRow)
              ) : (
                <div
                  className={classes.notResult}
                  style={{ alignItems: "center", flexDirection: "column" }}
                >
                  <img src={cone} alt="" />
                  <p className={classes.notResulText01}>
                    {i18n.replicate.notResultBox.noResultes}
                  </p>
                  <p className={classes.notResulText02}>
                    {i18n.replicate.notResultBox.trySearching}
                  </p>
                </div>
              )}
            </div>
            <div className={classes.btnBox}>
              <Button
                variant="contained"
                onClick={cancelClick}
                className={classes.btnCancel}
              >
                {i18n.cancel}
              </Button>
              <Button
                variant="contained"
                disabled={listSelected.length !== 0 ? false : true}
                onClick={process}
                className={classes.btnNext}
              >
                {i18n.next}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(ReplicateModal);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/Replicate.tsx